import { queryClient } from './query-client'

export const setUnavailableCache = (queryKey: any[], entity: any) => {
    const cachedEntity = queryClient.getQueryData(queryKey)
    if(cachedEntity === undefined){
        queryClient.setQueryData(queryKey, entity)
        queryClient.invalidateQueries(queryKey)
    }
}
